import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Compass, Loader2, Eye, EyeOff } from 'lucide-react';

const api = axios.create({ baseURL: '/api/sc-portal' });

export default function ScPortalLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (localStorage.getItem('sc_portal_token')) navigate('/sc-portal', { replace: true }); }, [navigate]);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post('/login', form);
      localStorage.setItem('sc_portal_token', res.data.token);
      localStorage.setItem('sc_portal_name', res.data.name || '');
      navigate('/sc-portal', { replace: true });
    } catch (err) { toast.error(err.response?.data?.message || 'Login failed'); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-6">
          <span className="h-12 w-12 rounded-2xl bg-indigo-600 text-white flex items-center justify-center mb-3"><Compass size={24} /></span>
          <h1 className="text-xl font-bold text-slate-800">Support Coordination portal</h1>
          <p className="text-sm text-slate-400">Sign in to view your plan</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-1">Email</label>
            <input type="email" required value={form.email} onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} className="w-full px-3 py-2 rounded-lg border border-slate-200 text-sm focus:border-slate-400 focus:ring-0" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-1">Password</label>
            <div className="relative">
              <input type={show ? 'text' : 'password'} required value={form.password} onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))} className="w-full px-3 py-2 pr-10 rounded-lg border border-slate-200 text-sm focus:border-slate-400 focus:ring-0" />
              <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-2.5 top-2.5 text-slate-400">{show ? <EyeOff size={17} /> : <Eye size={17} />}</button>
            </div>
          </div>
          <button type="submit" disabled={busy} className="w-full py-2.5 rounded-xl bg-indigo-600 text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
            {busy ? <Loader2 size={17} className="animate-spin" /> : null}Sign in
          </button>
        </form>
        <p className="text-center text-xs text-slate-300 mt-4">Powered by Rostery</p>
      </div>
    </div>
  );
}
